import { Point } from "@/types";

export const addPointInbetween = (a: Point, b: Point) => {
    return {
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2,
    };
};
